// extracted by mini-css-extract-plugin
module.exports = {"title":"UjcziCLnPIDAWWf8BIQgP","dialog":"Av2BslCVHFIgBStYhUX-y"};